<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h1 class="text-h1 mb-0">{{$tc('database.dbs')}}</h1>
    </template>

    <template v-slot:mainPanel>
      <v-row class="pl-2 pb-10 mb-0 mb-md-8">
        <v-expansion-panels flat tile multiple :mandatory="cat?true:false" v-model="openedPanel">

          <v-expansion-panel v-if="if_case">
            <v-expansion-panel-header class="casepanel" :expand-icon="cat?'':'$expand'" :class="cat?'disablepointer':''">
              <template>
                <v-row no-gutters>
                  <h2 class="text-h2 mb-0">{{$tc('home.judgments')}}</h2> 
                </v-row> 
              </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content eager>
              <v-row no-gutters class="mt-1">
                <!--ENGLISH Judgements separated-->
                <v-col cols="12" sm="6" class="hidden-sm-and-up">
                  <h3 class="text-h3 mb-0 mt-2">{{$tc('langs.en')}} </h3>
                  <v-simple-table dense class="dbs">
                    <tbody>
                      <tr v-for="(item,index) in en_case_dbs"  :key="index">
                          <td class="pl-0">{{ item.abbr }}</td>
                          <td class="px-0"><router-link class="font-weight-medium" :to="item.path">{{ item.name }}</router-link></td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>

                <!--CHINESE Judgements separated-->
                <v-col cols="12" sm="6" class="hidden-sm-and-up">       
                  <h3 class="text-h3 mb-0 mt-3"> {{$tc('langs.tc')}}</h3>
                  <v-simple-table dense class="dbs">
                    <tbody>
                      <tr v-for="(item,index) in tc_case_dbs" :key="index">
                          <td class="px-0"><router-link class="font-weight-medium" :to="item.path">{{ item.name }}</router-link>
                          </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>

                <!--BILINGUAL Judgements together-->
                <v-col cols="12" class="hidden-xs-only">       
                  <v-simple-table dense class="dbs">
                    <thead>
                      <tr>
                        <td class="pl-0" width="50px"></td> 
                        <td class="tddivider"  width="1px"></td>
                        <td class="pl-0" ><h3 class="text-h3"> {{$tc('langs.en')}}</h3></td>
                        <td class="tddivider"  width="1px"></td>
                        <td class="pl-0" width="45%"><h3 class="text-h3"> {{$tc('langs.tc')}}</h3></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in case_dbs" :key="index">
                        <td class="pl-0">{{ item.abbr }}</td> 
                        <td  class="tddivider"></td>
                        <td class="pl-0"><router-link class="font-weight-medium" :to="'/en'+item.path" >{{ item.name }}</router-link></td>
                        <td  class="tddivider"></td>
                        <td class="pl-0"><router-link v-if="item.chiname" class="font-weight-medium" :to="'/tc'+item.path">{{ item.chiname }}</router-link></td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
      
          <v-expansion-panel v-if="if_legis">
            <v-expansion-panel-header class="legispanel" :expand-icon="cat?'':'$expand'" :class="cat?'disablepointer':''">
              <template>
                <v-row no-gutters class="mt-1">
                  <h2 class="text-h2 mb-0">{{$tc('home.legislation')}}</h2> 
                </v-row>
              </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content eager>
              <v-row no-gutters class="mt-1">
                <!--ENGLISH Legis separated-->
                <v-col cols="12" sm="6" class="hidden-sm-and-up">
                  <h3 class="text-h3 mb-0 mt-2">  {{$tc('langs.en')}}</h3>
                  <v-simple-table dense class="dbs">
                    <tbody>
                      <tr v-for="(item, index) in en_legis_dbs" :key="index">
                        <td class="px-0"><router-link class="font-weight-medium" :to="item.path">{{ item.name }}</router-link></td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
                
                <!--CHINESE Legis separated-->
                <v-col cols="12" sm="6" class="hidden-sm-and-up">
                  <h3 class="text-h3 mb-0 mt-3"> {{$tc('langs.tc')}}</h3>
                  <v-simple-table dense class="dbs">
                    <tbody>
                      <tr v-for="(item,index) in tc_legis_dbs" :key="index">
                          <td class="px-0" >
                            <v-row no-gutters>
                              <router-link class="font-weight-medium" :to="item.path">{{ item.name }}</router-link>
                              <v-spacer></v-spacer> 
                              <router-link v-if="item.scpath" :to="item.scpath" class="text-right">(另见简体版)</router-link>
                            </v-row>
                          </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>

                <!--BILINGUAL Legis separated-->
                <v-col cols="12" class="hidden-xs-only">
                  <v-simple-table dense class="dbs">
                    <thead>
                      <tr>
                        <td class="pl-0" width="55%"><h3 class="text-h3"> {{$tc('langs.en')}}</h3></td>
                        <td class="tddivider"  width="1px"></td>
                        <td class="pl-0"><h3 class="text-h3"> {{$tc('langs.tc')}}</h3></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in legis_dbs" :key="index">
                        <td class="pl-0"><router-link class="font-weight-medium" :to="'/en'+item.path">{{ item.name }}</router-link></td>
                        <td class="tddivider"  width="1px"></td>
                        <td class="pl-0 pr-1">
                          <v-row no-gutters>
                            <router-link class="font-weight-medium pt-1" :to="'/tc'+item.path">{{ item.chiname }}</router-link>
                            <v-spacer></v-spacer> 
                            <router-link v-if="item.scpath" :to="item.scpath">(另见简体版)</router-link>
                          </v-row>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
                    
              </v-row> 
            </v-expansion-panel-content>
          </v-expansion-panel>
    
          <v-expansion-panel v-if="if_other">
            <v-expansion-panel-header class="otherpanel" :expand-icon="cat?'':'$expand'" :class="cat?'disablepointer':''">
              <template>
                <v-row no-gutters>
                  <h2 class="text-h2 mb-0">{{$tc('database.others')}}</h2> 
                </v-row>
              </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content eager>
                <v-row no-gutters class="mt-1">
                  <!--ENGLISH Others separated-->
                  <v-col cols="12" sm="6"  class="hidden-sm-and-up">
                    <h3 class="text-h3 mb-0 mt-2">{{$tc('langs.en')}}</h3>
                    <v-simple-table dense class="dbs" >
                      <tbody>
                        <tr v-for="(item,index) in en_other_dbs" :key="index">
                          <td class="px-0"><router-link class="font-weight-medium" :to="item.path">{{ item.name }}</router-link></td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>

                  <!--CHINESE Others separated-->
                  <v-col cols="12" sm="6"  class="hidden-sm-and-up mt-2">
                    <h3 class="text-h3 mb-0 mt-3"> {{$tc('langs.tc')}}</h3>
                    <v-simple-table dense class="dbs">
                      <tbody>
                        <tr v-for="(item,index) in tc_other_dbs" :key="index">
                          <td class="px-0" v-if="item.scpath">
                              <router-link class="font-weight-medium" :to="item.path">{{ item.name }}</router-link>
                          </td>
                          <td class="px-0" v-if="item.scpath"> 
                              <router-link v-if="item.scpath" :to="item.scpath">(另见简体版)</router-link>
                          </td>
                          <td class="px-0" v-else-if="!item.scpath" colspan="2">
                            <router-link class="font-weight-medium" :to="item.path">{{ item.name }}</router-link>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>

                  <!--BILINGUAL Others separated-->
                  <v-col cols="12" class="hidden-xs-only">
                    <v-simple-table dense class="dbs">
                      <thead>
                        <tr>
                          <td class="pl-0" width="55%"><h3 class="text-h3"> {{$tc('langs.en')}}</h3></td>
                          <td class="tddivider"  width="1px"></td>
                          <td class="pl-0"><h3 class="text-h3"> {{$tc('langs.tc')}}</h3></td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in other_dbs" :key="index">
                          <td class="pl-0"><router-link class="font-weight-medium" :to="'/en'+item.path">{{ item.name }}</router-link></td>
                          <td class="tddivider"  width="1px"></td>
                          <td class="pl-0 pr-1">
                            <v-row no-gutters class="px-0" >
                              <router-link class="font-weight-medium pt-1" :to="'/tc'+item.path">{{ item.chiname }}</router-link>
                              <v-spacer></v-spacer> 
                              <router-link v-if="item.scpath" :to="item.scpath" class="text-right">(另见简体版)</router-link>
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>

                </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

      </v-row>
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import StatusWidget from '../components/StatusWidget'
  export default {
    name: 'Databases',
    components:{
      ThreeColumn,
      StatusWidget
    },
    data () { 
      return {
      openedPanel: [0, 1, 2, 3, 4],
      cats: ['C', 'L', 'O'],
      cat: '',
      en_case_dbs:[
        {'name': 'Court of Final Appeal', 'path': '/en/cases/hkcfa/', 'abbr':'HKCFA'},
        {'name': 'United Kingdom Privy Council Judgments for Hong Kong', 'path': '/en/cases/ukpc/', 'abbr':'UKPC'},
        {'name': 'Court of Appeal', 'path': '/en/cases/hkca/', 'abbr':'HKCA'},
        {'name': 'Court of First Instance', 'path': '/en/cases/hkcfi/', 'abbr':'HKCFI'},
        {'name': 'Competition Tribunal', 'path': '/en/cases/hkct/', 'abbr':'HKCT'},
        {'name': 'District Court', 'path': '/en/cases/hkdc/', 'abbr':'HKDC'},
        {'name': 'Family Court', 'path': '/en/cases/hkfc/', 'abbr':'HKFC'},
        {'name': "Magistrates' Courts", 'path': '/en/cases/hkmagc/', 'abbr':'HKMagC'},
        {'name': "Coroner's Court", 'path': '/en/cases/hkcrc/', 'abbr':'HKCrC'},
        {'name': 'Labour Tribunal', 'path': '/en/cases/hklat/', 'abbr':'HKLaT'},
        {'name': 'Lands Tribunal', 'path': '/en/cases/hkldt/', 'abbr':'HKLdT'},
        {'name': 'Obscene Articles Tribunal', 'path': '/en/cases/hkoat/', 'abbr':'HKOAT'},
        {'name': 'Small Claims Tribunal', 'path': '/en/cases/hksct/', 'abbr':'HKSCT'}
      ],
      tc_case_dbs:[
        {'name': '終審法院', 'path': '/tc/cases/hkcfa/'},
        {'name': '上訴法庭', 'path': '/tc/cases/hkca/'},
        {'name': '原訟法庭', 'path': '/tc/cases/hkcfi/'},
        {'name': '競爭事務審裁處', 'path': '/tc/cases/hkct/'},
        {'name': '區域法院', 'path': '/tc/cases/hkdc/'},
        {'name': '家事法庭', 'path': '/tc/cases/hkfc/'},
        {'name': '裁判法院', 'path': '/tc/cases/hkmagc/'},
        {'name': '死因裁判法庭', 'path': '/tc/cases/hkcrc/'},
        {'name': '勞資審裁處', 'path': '/tc/cases/hklat'},
        {'name': '土地審裁處', 'path': '/tc/cases/hkldt/'},
        {'name': '淫褻物品審裁處', 'path': '/tc/cases/hkoat/'},
        {'name': '小額錢債審裁處', 'path': '/tc/cases/hksct/'}
      ],
      case_dbs:[ //for desktop version
        {'abbr': 'HKCFA','name': 'Court of Final Appeal', 'chiname': '終審法院', 'path': '/cases/hkcfa/'},
        {'abbr': 'UKPC', 'name': 'United Kingdom Privy Council Judgments for Hong Kong', 'path': '/cases/ukpc/'},
        {'abbr': 'HKCA','name': 'Court of Appeal', 'chiname': '上訴法庭', 'path': '/cases/hkca/'},
        {'abbr': 'HKCFI','name': 'Court of First Instance', 'chiname': '原訟法庭', 'path': '/cases/hkcfi/'},
        {'abbr': 'HKCT','name': 'Competition Tribunal','chiname': '競爭事務審裁處', 'path': '/cases/hkct/'},
        {'abbr': 'HKDC','name': 'District Court','chiname': '區域法院', 'path': '/cases/hkdc/'},
        {'abbr': 'HKFC','name': 'Family Court','chiname': '家事法庭', 'path': '/cases/hkfc/'},
        {'abbr': 'HKMagC','name': "Magistrates' Courts",'chiname': '裁判法院', 'path': '/cases/hkmagc/'},
        {'abbr': 'HKCrC','name': "Coroner's Court",'chiname': '死因裁判法庭', 'path': '/cases/hkcrc/'},
        {'abbr': 'HKLaT','name': 'Labour Tribunal','chiname': '勞資審裁處', 'path': '/cases/hklat/'},
        {'abbr': 'HKLdT','name': 'Lands Tribunal', 'chiname': '土地審裁處', 'path': '/cases/hkldt'},
        {'abbr': 'HKOAT','name': 'Obscene Articles Tribunal','chiname': '淫褻物品審裁處', 'path': '/cases/hkoat/'},
        {'abbr': 'HKSCT','name': 'Small Claims Tribunal','chiname': '小額錢債審裁處', 'path': '/cases/hksct/'}
      ],
      en_legis_dbs:[
        {'name': 'Hong Kong Ordinances', 'path': '/en/legis/ord/'},
        {'name': 'Hong Kong Regulations', 'path': '/en/legis/reg/'},
        {'name': 'Hong Kong Constitutional Instruments', 'path': '/en/legis/instrument/'},
        {'name': 'Historical Laws of Hong Kong', 'path': '/en/legis/histlaw/'},
        {'name': 'Arrangements with the Macao SAR', 'path': '/en/legis/hktmc/'},
        {'name': 'Arrangements with the Mainland', 'path': '/en/legis/hktml/'},
        {'name': 'Bilateral Agreements Concluded by the HKSAR Government', 'path': '/en/legis/bahkg/'},
        {'name': "Bilateral Agreements Concluded by the Central People's Government", 'path': '/en/legis/bacpg/'},
        {'name': 'Treaties', 'path': '/en/legis/hkts/'}
      ],
      tc_legis_dbs:[
        {'name': '香港條例', 'path': '/tc/legis/ord/', 'scpath':'/sc/legis/ord/'},
        {'name': '香港附屬法例', 'path': '/tc/legis/reg/', 'scpath':'/sc/legis/reg/'},
        {'name': '香港憲法文件', 'path': '/tc/legis/instrument/', 'scpath':'/sc/legis/instrument/'},
        {'name': '香港特別行政區與澳門特別行政區之間的安排', 'path': '/tc/legis/hktmc/'},
        {'name': '香港特別行政區與內地之間的安排', 'path': '/tc/legis/hktml/'},
        {'name': '香港特別行政區政府達成的雙邊協定', 'path': '/tc/legis/bahkg/'},
        {'name': '中央人民政府達成的雙邊協定', 'path': '/tc/legis/bacpg/'},
        {'name': '公約', 'path': '/tc/legis/hkts/'}
      ],
      legis_dbs:[ //for desktop version
        {'name': 'Hong Kong Ordinances','chiname': '香港條例', 'path': '/legis/ord/', 'scpath':'/sc/legis/ord/'},
        {'name': 'Hong Kong Regulations', 'chiname': '香港附屬法例','path': '/legis/reg/', 'scpath':'/sc/legis/reg/'},
        {'name': 'Hong Kong Constitutional Instruments','chiname': '香港憲法文件', 'path': '/legis/instrument/',  'scpath':'/sc/legis/instrument/'},
        {'name': 'Historical Laws of Hong Kong', 'path': '/legis/histlaw/'},
        {'name': 'Arrangements with the Macao SAR','chiname': '香港特別行政區與澳門特別行政區之間的安排', 'path': '/legis/hktmc/'},
        {'name': 'Arrangements with the Mainland','chiname': '香港特別行政區與內地之間的安排', 'path': '/legis/hktml/'},
        {'name': 'Bilateral Agreements Concluded by the HKSAR Government', 'chiname': '香港特別行政區政府達成的雙邊協定', 'path': '/legis/bahkg/'},
        {'name': "Bilateral Agreements Concluded by the Central People's Government", 'chiname': '中央人民政府達成的雙邊協定', 'path': '/legis/bacpg/'},
        {'name': 'Treaties','chiname': '公約', 'path': '/legis/hkts/'}
      ],
      en_other_dbs:[
        {'name': 'Hong Kong International Arbitration Centre', 'path': '/en/other/hkiac/'},
        {'name': 'Law Reform Commission Consultation Papers', 'path': '/en/other/hklrccp/'},
        {'name': 'Law Reform Commission Reports', 'path': '/en/other/hklrcr/'},
        {'name': 'Office of the Privacy Commissioner for Personal Data Administrative Appeals Board Decisions', 'path': '/en/other/pcpdaab/'},
        {'name': 'Office of the Privacy Commissioner for Personal Data Complaint Case Notes', 'path': '/en/other/pcpdc/'},
        {'name': 'Practice Directions', 'path': '/en/other/pd/'}
      ],
      tc_other_dbs:[
        {'name': '法律改革委員會諮詢文件', 'path': '/tc/other/hklrccp/', 'scpath': '/sc/other/hklrccp/'},
        {'name': '法律改革委員會報告書', 'path': '/tc/other/hklrcr/','scpath': '/sc/other/hklrcr/'},
        {'name': '個人資料私隱專員公署行政上訴委員會裁決', 'path': '/tc/other/pcpdaab/'},
        {'name': '個人資料私隱專員公署投訴個案簡述', 'path': '/tc/other/pcpdc/', 'scpath': '/sc/other/pcpdc/'},
        {'name': '實務指示', 'path': '/tc/other/pd/'}
      ],
      other_dbs:[ //for desktop version
        {'name': 'Hong Kong International Arbitration Centre','path': '/other/hkiac/'},
        {'name': 'Law Reform Commission Consultation Papers','chiname': '法律改革委員會諮詢文件',  'path': '/other/hklrccp/', 'scpath': '/sc/other/hklrccp/'},
        {'name': 'Law Reform Commission Reports','chiname': '法律改革委員會報告書', 'path': '/other/hklrcr/','scpath': '/sc/other/hklrcr/'},
        {'name': 'Office of the Privacy Commissioner for Personal Data Administrative Appeals Board Decisions','chiname': '個人資料私隱專員公署行政上訴委員會裁決', 'path': '/other/pcpdaab/'},
        {'name': 'Office of the Privacy Commissioner for Personal Data Complaint Case Notes','chiname': '個人資料私隱專員公署投訴個案簡述', 'path': '/other/pcpdc/','scpath': '/sc/other/pcpdc/'},
        {'name': 'Practice Directions','chiname': '實務指示', 'path': '/other/pd/'}
      ],
      //stat_wdgt:[],  //for stat
    }
  },
  watch:{
    '$route.fullPath': function () {
      this.cat = this.$route.query.cat || ''
    },
    /*'$i18n.locale': function(){
      window.document.title = `${this.$i18n.t('database.dbs')} | HKLII`
    }*/
  },
  computed:{
    if_case(){
      return (this.cat.toLowerCase() === 'c') || (this.cat === '')
    },
    if_legis(){
      return (this.cat.toLowerCase() === 'l') || (this.cat === '')
    },
    if_other(){
      return (this.cat.toLowerCase() === 'o') || (this.cat === '')
    },
    paths(){
      return [
        {text: 'HKLII', disabled: false, href: {name: 'home'}},
        {text: this.$i18n.t('database.dbs'), disabled: true}
      ]
    },
  },
  mounted(){
    this.cat = this.$route.query.cat || ''
    //window.document.title = `${this.$i18n.t('database.dbs')} | HKLII`
  },
  metaInfo(){
    return{
      title: this.$i18n.t('database.dbs'),
      meta: [
        {
          name: 'description',
          content: 'HKLII provides free access to Hong Kong legal information, including judgments and legislations.',
        }
      ],
    }
  },
}
</script>

<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  a {
    @include link-no-underline;
    line-height: 13pt ;
    padding-top: 4px !important;
    display: table-cell;
  }

  .v-expansion-panel{
    margin-bottom: 10px;
  }
  .v-expansion-panel-header--active{
    padding-top: 0px;
    padding-bottom: 0px;
    border: none !important;
  }
  .casepanel{
    background: var(--v-l_case-base);
  }
  .legispanel{
    background: var(--v-l_legis-base);
  }
   .otherpanel{
    background: var(--v-l_other-base);
  }

  .v-expansion-panel-header{
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid var(--v-liiblack-lighten3) ;
  }

  td {
    text-align: left;
    vertical-align: top;
    padding-top:4.5px !important;
    padding-bottom:4.5px !important;
  }

  .tddivider{
    border: none !important;
    padding: 0px 3px !important;
  }

  table{ /* not working at the moment */
    border-top: 1px solid var(--v-footergrey-base) !important;
  }
  
  .v-chip:hover *{
    cursor: pointer!important;
  }
  
  .disablepointer{ /*remove cursor pointer if the page only has a single panel*/
    cursor: auto;
  }

</style>